'use strict';

jQuery(document).ready(function ($) {

  $('#psp-projects').on('click', '.psp-st-toggle', function (e) {
    $(this).siblings('.psp-sub-tasks__wrap').toggleClass('is-active');
    $(this).toggleClass('is-active');
  });

  $('#psp-phases, #psp-archive-content').on('click', '.complete-sub-task-link', function (e) {

    e.preventDefault();

    var formID = $(this).attr('data-target');
    var project_id = $(this).attr('data-project');
    var task_id = $(this).attr('data-task');
    var progress = 100;
    var phase_progress = $(this).attr('data-phase-auto');
    var total_progress = $(this).attr('data-overall-auto');

    if ($(this).parents('.task-item').length) {
      var phase_id = $(this).parents('.task-item').find('.psp-task-title').data('phase_id'); // This is the wrong one for some reason
      var parent_id = $(this).parents('.task-item').find('.psp-task-title').data('task_id');
    } else if ($(this).parents('.sub-task-row').length) {
      var phase_id = $(this).parents('.sub-task-row').prev('.task-row').data('phase_id');
      var parent_id = $(this).parents('.sub-task-row').prev('.task-row').data('task_id');
    }

    // Single, Dashboard, and Your Tasks view
    var $parentTask = $('.psp-single-' + project_id + ' .psp-phase[data-phase_id="' + phase_id + '"] .psp-task-id-' + parent_id + ', .psp-task-project-' + project_id + ' .psp-task-id-' + parent_id + ', .project-' + project_id + '[data-task_id="' + parent_id + '"]');

    // Update dynamically
    psp_update_sub_task_progress(project_id, phase_id, task_id, parent_id, $parentTask, progress, phase_progress, total_progress);

    var the_parent = $(this).parents('.sub-task-item'),
        target = $(the_parent).find('.status');

    if (progress == '100') {
      $(the_parent).addClass('complete');
    } else {
      $(the_parent).removeClass('complete');
    }

    $(target).removeClass().addClass('status').addClass('psp-' + progress);
    $(the_parent).attr('data-progress', progress);
  });

  $('#psp-phases, #psp-archive-content').on('click', '.sub-task-save-button', function (e) {

    e.preventDefault();

    var task_element = $(this).parents('.sub-task-select').find('#edit-sub-task-select-' + $(this).attr('data-phase') + '-' + $(this).attr('data-task'));
    var project_id = $(this).attr('data-project');
    var task_id = $(this).attr('data-task');

    if ($(this).parents('.task-item').length) {
      var phase_id = $(this).parents('.task-item').find('.psp-task-title').data('phase_id');
      var parent_id = $(this).parents('.task-item').find('.psp-task-title').data('task_id');
    } else if ($(this).parents('.sub-task-row').length) {
      var phase_id = $(this).parents('.sub-task-row').prev('.task-row').data('phase_id');
      var parent_id = $(this).parents('.sub-task-row').prev('.task-row').data('task_id');
    }

    var progress = $(task_element).val();
    var parent_div = $(this).parents('.task-select');

    var phase_progress = $(this).attr('data-phase-auto');
    var total_progress = $(this).attr('data-overall-auto');

    // Single, Dashboard, and Your Tasks view
    var $parentTask = $('.psp-single-' + project_id + ' .psp-phase[data-phase_id="' + phase_id + '"] .psp-task-id-' + parent_id + ', .psp-task-project-' + project_id + ' .psp-task-id-' + parent_id + ', .project-' + project_id + '[data-task_id="' + parent_id + '"]');

    psp_update_sub_task_progress(project_id, phase_id, task_id, parent_id, $parentTask, progress, phase_progress, total_progress);

    var the_parent = $(this).parents('.sub-task-item'),
        target = $(the_parent).find('.status');

    $(target).removeClass().addClass('status').addClass('psp-' + progress);
    $(the_parent).attr('data-progress', progress);

    if (progress == '100') {
      $(the_parent).addClass('complete');
    } else {
      $(the_parent).removeClass('complete');
    }

    $(this).parents('.psp-sub-task-edit-links').removeClass('is-active');
  });

  $('#psp-phases, #psp-archive-content').on('click', '.sub-task-edit-link', function (e) {

    e.preventDefault();
    $(this).parents('.psp-sub-task-edit-links').addClass('is-active');

    // var the_parent = $(this).parents('.sub-task-item');
    // $(the_parent).children('.sub-task-select').fadeIn('slow');
  });
});

function psp_update_sub_task_progress(project_id, phase_id, task_id, parent_id, $parentTask, progress, phase_progress, total_progress) {

  var ajaxurl = jQuery('#psp-ajax-url').val();

  jQuery.ajax({
    url: ajaxurl + "?action=psp_update_sub_task_fe",
    type: 'post',
    data: {
      project_id: project_id,
      phase_id: phase_id,
      task_id: task_id,
      parent_id: parent_id,
      progress: progress
    },
    success: function success(response) {

      $parentTask.find('.psp-progress-bar .status').removeClass().addClass('status').addClass('psp-' + response.data.parent_progress);
      $parentTask.attr('data-progress', response.data.parent_progress);

      psp_update_my_task_count(project_id, phase_id);

      if (typeof phase_progress !== 'undefined' && phase_progress == 'Yes') {
        psp_update_phase_completion(project_id, phase_id);
      }

      if (typeof total_progress !== 'undefined' && total_progress == 'Yes') {
        psp_update_total_progress(project_id);
      }
    },
    error: function error(data) {
      console.log(data);
    }
  });
}
'use strict';

(function ($) {

	$(document).ready(function () {

		$(document).on('click', '.fieldhelpers-field-repeater-add-button', function (event) {

			if ($('select[data-fieldhelpers-field-select="assigned"]').length) {
				$('select[data-fieldhelpers-field-select="assigned"]').select2();
			}

			if ($('.subtask-description') && typeof tinyMCE !== 'undefined') {
				tinymce.init({
					selector: 'textarea.subtask-description',
					theme: 'modern',
					skin: 'lightgray',
					menubar: false,
					statusbar: true,
					plugins: 'lists',
					elements: 'pre-details',
					mode: 'exact',
					toolbar: "bold italic underline justifyleft justifycenter justifyright outdent indent code formatselect numlist bullist"
				});
			}

			$('.psp-add-task-modal').find('input[data-fieldhelpers-field-datepicker]').each(function (index, preview) {

				var date = $(preview).next('input[type="hidden"]').val(),
				    month = date.substring(4, 6),
				    day = date.substring(6, 8),
				    year = date.substring(0, 4),
				    dateObject = new Date(year + '-' + month + '-' + day);

				// Don't populate a value if there is no due date
				if ($(preview).next('input[type="hidden"]').val() != '') {
					// https://stackoverflow.com/a/16048201
					dateObject.setTime(dateObject.getTime() + dateObject.getTimezoneOffset() * 60 * 1000);
				} else {
					dateObject = null;
				}

				$(preview).datepicker('setDate', dateObject).on('changeDate', function (e) {

					console.log('is see change!');

					$(this).siblings('.psp-datepicker').val($(this).val());
				});
			});
		});

		$('#psp-phases').on('click', '.fe-edit-task-link', function (event) {

			var target = $(this).attr('href');
			var $modal = $(target);
			var values = $(this).data();

			var subTasks = values['sub_task'];

			clearRepeater($modal);

			addRows(subTasks, $modal);

			$modal.find('input[data-fieldhelpers-field-datepicker]').each(function (index, preview) {

				var date = $(preview).next('input[type="hidden"]').val(),
				    month = date.substring(4, 6),
				    day = date.substring(6, 8),
				    year = date.substring(0, 4),
				    dateObject = new Date(year + '-' + month + '-' + day);

				// Don't populate a value if there is no due date
				if ($(preview).next('input[type="hidden"]').val() != '') {
					// https://stackoverflow.com/a/16048201
					dateObject.setTime(dateObject.getTime() + dateObject.getTimezoneOffset() * 60 * 1000);
				} else {
					dateObject = null;
				}

				$(preview).datepicker('setDate', dateObject).on('changeDate', function (e) {

					console.log('is see change!');

					$(this).siblings('.psp-datepicker').val($(this).val());
				});
			});
		});

		$('#psp-phases').on('click', '.psp-fe-add-element', function (event) {

			var target = $(this).attr('href');
			var $modal = $(target);

			clearRepeater($modal);
		});
	});

	/*
 $( document ).on( 'psp-fe-task-edit-modal-populated', function( event, $modal, values ) {
 		// With our Included Datepicker, we don't want to do it based on the field value. No tomfoolery necessary
 	$modal.find( 'input.psp-datepicker' ).each( function( index, field ) {
 			$( field ).datepicker();
 		} );
 	} ); */

	$(document).on('psp-fe-deleted-task', function (event, phase_index, task_index) {

		if (typeof rbmFHinitField === 'function') {

			// Re-init the Repeater field
			rbmFHinitField($('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"]').closest('.psp-frontend-field'));
		} else {
			// Oh well, Repeaters will be broken on Task Delete if an older RBM FH is running
		}
	});

	/**
  * Clears the Sub Task Repeater of all Values
  *
  * @param		{object} $modal Task Edit Modal jQuery Object
  *
  * @since		{{VERSION}}
  * @return		void
  */
	function clearRepeater() {
		var $modal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


		$modal.find('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"] .fieldhelpers-field-repeater-row').remove();
	}

	/**
  * Clears the Sub Task Repeater of all Values
  *
  * @param		{Array} subTasks      Array of Objects representing the values for each Row
  * @param		{object} $modal       Task Edit Modal jQuery Object
  *
  * @since		{{VERSION}}
  * @return		void
  */
	function addRows(subTasks) {
		var $modal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


		// Add Rows
		for (var subTask in subTasks) {

			$modal.find('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"] .fieldhelpers-field-repeater-add-button').click();
		}

		// Populate Rows
		$modal.find('.psp_st-fieldhelpers-field[data-fieldhelpers-name="sub_tasks"] .fieldhelpers-field-repeater-row').each(function (index, row) {

			var subTask = subTasks[index];

			for (var key in subTask) {

				if (key == 'assigned') {

					var strAssigned = String(subTask.assigned);

					if (strAssigned.indexOf(',') > -1) {
						var assigned = strAssigned.split(',');
					} else if (strAssigned === "") {
						var assigned = 0;
					} else {
						var assigned = strAssigned;
					}

					$(row).find('select[data-fieldhelpers-field-select="assigned"]').val(assigned).trigger('change');
				} else {

					var value = subTask[key];

					$(row).find('*[name$="' + key + ']"]').val(value);
				}
			}
		});

		if ($('.subtask-description') && typeof tinyMCE !== 'undefined') {
			tinymce.init({
				selector: 'textarea.subtask-description',
				theme: 'modern',
				skin: 'lightgray',
				menubar: false,
				statusbar: true,
				plugins: 'lists',
				elements: 'pre-details',
				mode: 'exact',
				toolbar: "bold italic underline justifyleft justifycenter justifyright outdent indent code formatselect numlist bullist"
			});
		}
	}
})(jQuery);